// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

import FlexColumn from "common/components/styled-components/FlexColumn";
import StackedBar from "./StackedBar";
import SectionDescription from "./styled-components/SectionDescription";

interface NutritionProps {
  averageFootprint: number;
  userFootprint: number;
  averageSectorFootprint: number;
  userSectorFootprint: number;
}

function Nutrition({
  averageFootprint,
  userFootprint,
  averageSectorFootprint,
  userSectorFootprint,
}: NutritionProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  return (
    <FlexColumn gap={upDesktopScreen ? 20 : 24}>
      <StackedBar
        title="Alimentación"
        averageColor="#e67222"
        averageValue={averageSectorFootprint}
        userColor="#f6a66d"
        userValue={userSectorFootprint}
        total={Math.max(averageFootprint, userFootprint)}
      />
      <SectionDescription>
        Para mejorar tu huella con respecto a la alimentación sería conveniente
        modificar tu hábitos de consumos y compra, es decir, consumir productos
        de temporada y cercanos (sería ideal que fueran ecológicos). Además,
        aumentar el consumo de productos de origen vegetal frente a los de
        origen animal.
      </SectionDescription>
    </FlexColumn>
  );
}

export default Nutrition;
